import moment from 'moment';
import React, { useCallback, useRef, useState } from 'react';
import ModalLoader from '../../../modal/modal_loader';
import ModalAlert from '../../components/modal/modal_alert';
import axios from '../../sagas/axios';

// 使われていない
const Edit = ({
  recruitTenant,
  isApp,
  avatarUrlMedium,
  countriesPrefs,
  prefsCities,
  currentUser = [],
}) => {
  const [tenantType, setTenantType] = useState(
    recruitTenant.tenant_type || 'individual'
  );
  const [tenantName, setTenantName] = useState(recruitTenant.tenant_name || '');
  const [tenantNameKana, setTenantNameKana] = useState(
    recruitTenant.tenant_name_kana || ''
  );
  const [displayTenantName, setDisplayTenantName] = useState(
    recruitTenant.display_tenant_name || ''
  );
  const [prefId, setPrefId] = useState(recruitTenant.pref_id || '');
  const [cityId, setCityId] = useState(recruitTenant.city_id || '');
  const [address, setAddress] = useState(recruitTenant.address || '');
  const [addressKana, setAddressKana] = useState(
    recruitTenant.address_kana || ''
  );
  const [tel, setTel] = useState(recruitTenant.tel || '');
  const [ownerFamilyname, setOwnerFamilyname] = useState(
    recruitTenant.owner_familyname || currentUser.familyname || ''
  );
  const [ownerFirstname, setOwnerFirstname] = useState(
    recruitTenant.owner_firstname || currentUser.firstname || ''
  );
  const [ownerFamilynameKana, setOwnerFamilynameKana] = useState(
    recruitTenant.owner_familyname_kana || ''
  );
  const [ownerFirstnameKana, setOwnerFirstnameKana] = useState(
    recruitTenant.owner_firstname_kana || ''
  );
  const [birthdate, setBirthdate] = useState(
    moment(recruitTenant.birthdate).format('YYYY-MM-DD') || ''
  );
  const [staffFamilyname, setStaffFamilyname] = useState(
    recruitTenant.staff_familyname || ''
  );
  const [staffFirstname, setStaffFirstname] = useState(
    recruitTenant.staff_firstname || ''
  );
  const [staffFamilynameKana, setStaffFamilynameKana] = useState(
    recruitTenant.staff_familyname || ''
  );
  const [staffFirstnameKana, setStaffFirstnameKana] = useState(
    recruitTenant.staff_firstname_kana || ''
  );
  const [staffEmail, setStaffEmail] = useState(recruitTenant.staff_email || '');
  const [staffTel, setStaffTel] = useState(recruitTenant.staff_tel || '');
  const [aboutUsTitle, setAboutUsTitle] = useState(
    recruitTenant.about_us_title || ''
  );
  const [aboutUsBody, setAboutUsBody] = useState(
    recruitTenant.about_us_body || ''
  );
  const [aboutFutureTitle, setAboutFutureTitle] = useState(
    recruitTenant.about_future_title || ''
  );
  const [aboutFutureBody, setAboutFutureBody] = useState(
    recruitTenant.about_future_body || ''
  );
  const [aboutPastBody, setAboutPastBody] = useState(
    recruitTenant.about_past_body || ''
  );
  const [image, setImage] = useState(avatarUrlMedium || '');
  const [selectedCityId, setSelectedCityId] = useState(
    recruitTenant.pref_id
      ? prefsCities.filter(
          (prefsCity) => prefsCity.pref_id == recruitTenant.pref_id
        )
      : []
  );
  const successRef = useRef(null);
  const errorRef = useRef(null);
  const loaderRef = useRef(null);

  const isDisabled =
    tenantType === 'company'
      ? !tenantName ||
        !tenantNameKana ||
        !displayTenantName ||
        !prefId ||
        !address ||
        !addressKana ||
        !tel ||
        !birthdate ||
        !ownerFamilyname ||
        !ownerFirstname ||
        !ownerFamilynameKana ||
        !ownerFirstnameKana ||
        !staffFamilyname ||
        !staffFirstname ||
        !staffFamilynameKana ||
        !staffFirstnameKana ||
        !staffEmail ||
        !staffTel ||
        !aboutUsBody ||
        !aboutFutureBody ||
        !aboutPastBody
      : !prefId ||
        !birthdate ||
        !ownerFamilyname ||
        !ownerFirstname ||
        !ownerFamilynameKana ||
        !ownerFirstnameKana ||
        !aboutUsBody ||
        !aboutFutureBody ||
        !aboutPastBody;

  const onChangeImageData = useCallback(
    (imageFile) => {
      let formData = new FormData();
      formData.append('file', imageFile);
      axios
        .patch(
          `/api/recruit_tenants/${recruitTenant.id}/upload_avatar`,
          formData
        )
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.status === 200) {
            setImage(response.data.avatar_url_medium);
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
    },
    [loaderRef, errorRef]
  );

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      loaderRef.current.openModal();
      const body = JSON.stringify({
        tenant_type: tenantType,
        tenant_name: tenantName,
        tenant_name_kana: tenantNameKana,
        display_tenant_name: displayTenantName,
        pref_id: prefId,
        city_id: cityId,
        address: address,
        address_kana: addressKana,
        tel: tel,
        owner_familyname: ownerFamilyname,
        owner_firstname: ownerFirstname,
        owner_familyname_kana: ownerFamilynameKana,
        owner_firstname_kana: ownerFirstnameKana,
        birthdate: birthdate,
        staff_familyname: staffFamilyname,
        staff_firstname: staffFirstname,
        staff_familyname_kana: staffFamilynameKana,
        staff_firstname_kana: staffFirstnameKana,
        staff_email: staffEmail,
        staff_tel: staffTel,
        about_us_title: aboutUsTitle,
        about_us_body: aboutUsBody,
        about_future_title: aboutFutureTitle,
        about_future_body: aboutFutureBody,
        about_past_body: aboutPastBody,
      });
      axios
        .post(`/api/recruit_tenants/${recruitTenant.id}/update`, body)
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.status === 200) {
            successRef.current.openModal();
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
    },
    [
      loaderRef,
      successRef,
      errorRef,
      recruitTenant,
      tenantType,
      tenantName,
      tenantNameKana,
      displayTenantName,
      prefId,
      cityId,
      address,
      addressKana,
      tel,
      ownerFamilyname,
      ownerFirstname,
      ownerFamilynameKana,
      ownerFirstnameKana,
      birthdate,
      staffFamilyname,
      staffFirstname,
      staffFamilynameKana,
      staffFirstnameKana,
      staffEmail,
      staffTel,
      aboutUsTitle,
      aboutUsBody,
      aboutFutureTitle,
      aboutFutureBody,
      aboutPastBody,
    ]
  );

  const toRecruitNewPage = useCallback(() => {
    window &&
      (window.location.href = `/recruits/tenants/${recruitTenant.id}/new`);
  });

  const countriesPrefSelect = countriesPrefs.map((countriesPref) => {
    return (
      <option value={countriesPref.id} key={countriesPref.id}>
        {countriesPref.name}
      </option>
    );
  });

  const prefsCitySelect = selectedCityId.map((prefsCity) => {
    return (
      <option value={prefsCity.city_id} key={prefsCity.city_id}>
        {prefsCity.city_name}
      </option>
    );
  });

  const changePrefId = (e) => {
    setPrefId(e.target.value);
    setCityId(0);
    setSelectedCityId(
      prefsCities.filter((prefsCity) => prefsCity.pref_id == e.target.value)
    );
  };

  const changeCityId = (e) => {
    setCityId(e.target.value);
  };

  const changeTenantType = () => {
    if (tenantType === 'company') {
      setTenantType('individual');
    } else {
      setTenantType('company');
    }
  };

  return (
    <div>
      <main
        style={{ paddingBottom: isApp == false ? '165px' : '66px' }}
        className="bg-white h-100 pt-3 min-vh-100"
      >
        <div className="container col-10 col-md-8 col-lg-6">
          <h1 className="text-fz-20px text-center mb-3">
            {tenantType === 'company'
              ? 'ビジネス登録（法人・事業者）'
              : 'ビジネス登録（個人）'}
          </h1>
          <button
            type="button"
            className={'col-6 a-button a-button__top a-button__top--outline'}
            onClick={(e) => changeTenantType(e)}
          >
            {tenantType === 'company'
              ? '個人の方はこちら'
              : '法人・事業者の方はこちら'}
          </button>
        </div>
        <div className="container col-10 col-md-8 col-lg-6 p-3_5 d-flex justify-content-around">
          <label htmlFor="image">
            <a
              className={`card border-0 d-flex justify-content-center align-items-center hov--default p-3_5 d-block`}
            >
              {image && !image.match(/img_noimage/) ? (
                <img
                  src={image}
                  alt="image"
                  className="card-img-top card-img-top--list_eventreport mb-0 w-100"
                />
              ) : (
                <img
                  src="/assets2019/img/icon_camera.svg"
                  className="card-img-top card-img-top--list_eventreport mb-0 w-100"
                />
              )}
              <input
                type="file"
                accept="image/png, image/jpeg"
                onChange={(e) => {
                  onChangeImageData(e.target.files[0]);
                }}
                id="image"
                style={{ display: 'none' }}
              />
            </a>
          </label>
        </div>

        {tenantType === 'company' && (
          <div>
            <div className="container col-10 col-md-8 col-lg-6">
              <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
                事業者名（正式名称）
              </p>
            </div>
            <div className="mb-0">
              <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
                <input
                  type="text"
                  className="p-0 w-100 textarea--eventreport bg-gray"
                  value={tenantName}
                  onChange={(e) => setTenantName(e.target.value)}
                />
              </div>
            </div>

            <div className="container col-10 col-md-8 col-lg-6">
              <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
                事業者名（かな）
              </p>
            </div>
            <div className="mb-0">
              <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
                <input
                  type="text"
                  className="p-0 w-100 textarea--eventreport bg-gray"
                  value={tenantNameKana}
                  onChange={(e) => setTenantNameKana(e.target.value)}
                />
              </div>
            </div>

            <div className="container col-10 col-md-8 col-lg-6">
              <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
                事業者表示名（サイト上への掲載情報）
              </p>
            </div>
            <div className="mb-0">
              <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
                <input
                  type="text"
                  className="p-0 w-100 textarea--eventreport bg-gray"
                  value={displayTenantName}
                  onChange={(e) => setDisplayTenantName(e.target.value)}
                />
              </div>
            </div>
          </div>
        )}

        <div className="mb-0">
          <div className="container col-10 col-md-8 col-lg-6 p-3_5">
            <div className="row">
              <div className="col-12">
                <p className="text-fz-14px text-fw-bold text-222 mt-3 d-inline-block">
                  {(tenantType === 'company' ? '法人代表者の' : '') + 'お名前'}
                </p>
              </div>
              <div className="col-5 p-3_5 bg-gray textarea-container--recruits">
                <input
                  type="text"
                  className="p-0 w-100 textarea--eventreport bg-gray"
                  value={ownerFamilyname}
                  onChange={(e) => setOwnerFamilyname(e.target.value)}
                  placeholder="田中"
                />
              </div>
              <div className="col-5 offset-1 p-3_5 bg-gray textarea-container--recruits">
                <input
                  type="text"
                  className="p-0 w-100 textarea--eventreport bg-gray"
                  value={ownerFirstname}
                  onChange={(e) => setOwnerFirstname(e.target.value)}
                  placeholder="太郎"
                />
              </div>
              <div className="col-12">
                <p className="text-fz-14px text-fw-bold text-222 mt-3 d-inline-block">
                  {(tenantType === 'company' ? '法人代表者の' : '') +
                    'おなまえ'}
                </p>
              </div>
              <div className="col-5 p-3_5 bg-gray textarea-container--recruits">
                <input
                  type="text"
                  className="p-0 w-100 textarea--eventreport bg-gray"
                  value={ownerFamilynameKana}
                  onChange={(e) => setOwnerFamilynameKana(e.target.value)}
                  placeholder="たなか"
                />
              </div>
              <div className="col-5 offset-1 p-3_5 bg-gray textarea-container--recruits">
                <input
                  type="text"
                  className="p-0 w-100 textarea--eventreport bg-gray"
                  value={ownerFirstnameKana}
                  onChange={(e) => setOwnerFirstnameKana(e.target.value)}
                  placeholder="たろう"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container col-10 col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
            お住まい
          </p>
        </div>
        <div className="mb-0">
          <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
            <select
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark bg-gray"
              value={prefId}
              onChange={changePrefId}
            >
              <option value={0} key={0}>
                選択してください
              </option>
              {countriesPrefSelect}
            </select>
          </div>
        </div>
        {/* <div className="container col-10 col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
            市区町村
          </p>
        </div>
        <div className="mb-0 bg-white">
          <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
            <select
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark bg-gray"
              value={cityId}
              onChange={changeCityId}
            >
              <option value={0} key={0}>
                選択してください
              </option>
              {prefsCitySelect}
            </select>
          </div>
        </div> */}

        {tenantType === 'company' && (
          <div>
            <div className="container col-10 col-md-8 col-lg-6">
              <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
                住所
              </p>
            </div>
            <div className="mb-0">
              <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
                <input
                  type="text"
                  className="p-0 w-100 textarea--eventreport bg-gray"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>
            </div>

            <div className="container col-10 col-md-8 col-lg-6">
              <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
                住所（かな）
              </p>
            </div>
            <div className="mb-0">
              <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
                <input
                  type="text"
                  className="p-0 w-100 textarea--eventreport bg-gray"
                  value={addressKana}
                  onChange={(e) => setAddressKana(e.target.value)}
                />
              </div>
            </div>

            <div className="container col-10 col-md-8 col-lg-6">
              <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
                電話
              </p>
            </div>
            <div className="mb-0">
              <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
                <input
                  type="text"
                  className="p-0 w-100 textarea--eventreport bg-gray"
                  value={tel}
                  onChange={(e) => setTel(e.target.value)}
                />
              </div>
            </div>
          </div>
        )}

        <div className="container col-10 col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
            {tenantType === 'company' ? '設立年月日' : '生年月日'}
          </p>
        </div>
        <div className="mb-3">
          <div className=" container col-10 col-md-8 col-lg-6 bg-gray textarea-container--recruits">
            <label
              htmlFor="party-start-datetime-input-form"
              className="row justify-content-between p-3_5"
            >
              <input
                type="date"
                className="datetimepicker form-style-reset p-0 textarea--eventreport bg-gray"
                id="party-start-datetime-input-form"
                defaultValue="1990-01-01"
                onChange={(e) =>
                  setBirthdate(moment(e.target.value).format('YYYY-MM-DD'))
                }
                autoComplete="off"
              />
            </label>
          </div>
        </div>

        {tenantType === 'company' && (
          <div>
            <div className="mb-0">
              <div className="container col-10 col-md-8 col-lg-6 p-3_5">
                <div className="row">
                  <div className="col-12">
                    <p className="text-fz-14px text-fw-bold text-222 mt-3 d-inline-block">
                      担当スタッフのお名前
                    </p>
                  </div>
                  <div className="col-5 p-3_5 bg-gray textarea-container--recruits">
                    <input
                      type="text"
                      className="p-0 w-100 textarea--eventreport bg-gray"
                      value={staffFamilyname}
                      onChange={(e) => setStaffFamilyname(e.target.value)}
                    />
                  </div>
                  <div className="col-5 offset-1 p-3_5 bg-gray textarea-container--recruits">
                    <input
                      type="text"
                      className="p-0 w-100 textarea--eventreport bg-gray"
                      value={staffFirstname}
                      onChange={(e) => setStaffFirstname(e.target.value)}
                    />
                  </div>
                  <div className="col-12">
                    <p className="text-fz-14px text-fw-bold text-222 mt-3 d-inline-block">
                      担当スタッフのおなまえ
                    </p>
                  </div>
                  <div className="col-5 p-3_5 bg-gray textarea-container--recruits">
                    <input
                      type="text"
                      className="p-0 w-100 textarea--eventreport bg-gray"
                      value={staffFamilynameKana}
                      onChange={(e) => setStaffFamilynameKana(e.target.value)}
                    />
                  </div>
                  <div className="col-5 offset-1 p-3_5 bg-gray textarea-container--recruits">
                    <input
                      type="text"
                      className="p-0 w-100 textarea--eventreport bg-gray"
                      value={staffFirstnameKana}
                      onChange={(e) => setStaffFirstnameKana(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="container col-10 col-md-8 col-lg-6">
              <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
                担当スタッフのメールアドレス
              </p>
            </div>
            <div className="mb-0">
              <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
                <input
                  type="text"
                  className="p-0 w-100 textarea--eventreport bg-gray"
                  value={staffEmail}
                  onChange={(e) => setStaffEmail(e.target.value)}
                />
              </div>
            </div>
            <div className="container col-10 col-md-8 col-lg-6">
              <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
                担当スタッフの電話番号
              </p>
            </div>
            <div className="mb-0">
              <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
                <input
                  type="text"
                  className="p-0 w-100 textarea--eventreport bg-gray"
                  value={staffTel}
                  onChange={(e) => setStaffTel(e.target.value)}
                />
              </div>
            </div>
          </div>
        )}

        {/* <div className="container col-10 col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
            {'私' + (tenantType === 'company' ? 'たち' : '') + 'について タイトル'}
          </p>
        </div>
        <div className="mb-0">
          <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport bg-gray"
              value={aboutUsTitle}
              onChange={(e) => setAboutUsTitle(e.target.value)}
            />
          </div>
        </div> */}
        <div className="container col-10 col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
            {'私' +
              (tenantType === 'company' ? 'たち' : '') +
              'について（自己紹介・活動内容）'}
          </p>
        </div>
        <div className="mb-0">
          <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
            <textarea
              className="p-0 w-100 bg-gray textarea-longtext-recruits"
              value={aboutUsBody}
              onChange={(e) => setAboutUsBody(e.target.value)}
            />
          </div>
        </div>
        {/* <div className="container col-10 col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
            将来について タイトル
          </p>
        </div>
        <div className="mb-0">
          <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport bg-gray"
              value={aboutFutureTitle}
              onChange={(e) => setAboutFutureTitle(e.target.value)}
            />
          </div>
        </div> */}
        <div className="container col-10 col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
            これから（将来）のこと
          </p>
        </div>
        <div className="mb-0">
          <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
            <textarea
              className="p-0 w-100 bg-gray textarea-longtext-recruits"
              value={aboutFutureBody}
              onChange={(e) => setAboutFutureBody(e.target.value)}
              placeholder="記入例）&#13;もともとバスケが大好きで、高校時代はインターハイに出場したこともあります。いつかはスポーツに素晴らしさを広められる仕事やプロジェクトに関わりたいなと思っています。"
            />
          </div>
        </div>
        <div className="container col-10 col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-222 mb-2 mt-3 d-inline-block">
            やってきたこと（履歴書・職務経歴書）
          </p>
          <p className="text-fz-11px">*つながったお相手にのみ表示されます。</p>
        </div>
        <div className="mb-0">
          <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
            <textarea
              className="p-0 w-100 bg-gray textarea-longtext-recruits"
              value={aboutPastBody}
              onChange={(e) => setAboutPastBody(e.target.value)}
              placeholder="記入例）&#13;2010年3月　まぐろ高等学校卒業&#13;2010年4月　つな大学経済学部入学&#13;2014年3月　つな大学経済学部卒業&#13;2014年4月　パンくずWEB株式会社入社&#13;　ウェブデザイナーとしてECアプリ制作に従事&#13;2018年7月　おがくずAPP株式会社入社&#13;　なめこ育成アプリ開発"
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6 d-flex justify-content-around">
          <div
            className="container d-flex justify-content-around mt-5"
            style={{ marginBottom: isApp ? '24px' : '' }}
          >
            <button
              type="button"
              className={`col-6 a-button a-button__top a-button--orange mr-2 w-100 ${
                isApp == false ? 'mb-2' : ''
              }`}
              onClick={(e) => onSubmit(e)}
              disabled={isDisabled}
            >
              募集登録へ進む
            </button>
          </div>
        </div>
      </main>
      <ModalAlert
        ref={successRef}
        id="modalAlertSuccess"
        title=" "
        content="登録に成功しました。"
        approveFunc={toRecruitNewPage}
      />
      <ModalAlert
        ref={errorRef}
        id="modalAlertError"
        title=" "
        content="登録に失敗しました。時間をおいてもう一度お試しください。"
      />
      <ModalLoader ref={loaderRef} />
    </div>
  );
};

export default Edit;
